import React from "react";
import PageHeader from '@components/PageHeader';
import PageFooter from '@components/PageFooter';
import EventStore from '@stores/EventStore';
import WelcomeStore from '@stores/WelcomeStore';
import utils from '@utils/utils';
import { observer } from 'mobx-react';
import { reaction } from 'mobx';

@observer
export default class WelcomePage extends React.Component {
    constructor(props) {
        super(props);
        this.naviInfo = {
            userAgent: window.navigator.userAgent,
            cookieEnabled: window.navigator.cookieEnabled ? 'true' : 'false',
            href: window.location.href,
            errorInfo: "Mobile client loaded app.",
            clientID: utils.getReceivePrefix() + utils.getID()
        }

        WelcomeStore.loggingService(this.naviInfo);
        
    }

    endReaction = reaction(() => EventStore.errorObj, () => {
        this.naviInfo.errorInfo = EventStore.errorObj.errorStack.toString();
        this.naviInfo.clientID = EventStore.errorObj.clientID;
        WelcomeStore.loggingService(this.naviInfo);
    });

    endReactionTwo = reaction(() => EventStore.killPolling, () => {
        if(EventStore.killPolling === true) {
            WelcomeStore.welcomeMessage = "Error reaching Service: Please refresh the page or try again later.";
        }
    });

    endReactionThree = reaction(() => EventStore.pollingStarted, () => {
        if(EventStore.pollingStarted === true) {
            WelcomeStore.welcomeMessage = "Welcome. Your session has begun, waiting on Representative.";
        }
    });

    retryPolling = () => {
        if(EventStore.pollingStarted === false) {
            this.naviInfo.errorInfo = "Manually triggered long polling.";
            WelcomeStore.loggingService(this.naviInfo);
            EventStore.longPollEvents();
        } else if(EventStore.killPolling === true) {
            this.naviInfo.errorInfo = "Manually triggered long polling due to polling ending.";
            WelcomeStore.loggingService(this.naviInfo);
            EventStore.resetPolling();
        }
    }

    componentWillUnmount() {
        this.endReaction();
        this.endReactionTwo();
        this.endReactionThree();
    }

    render() {
        return (
            <div>
                <PageHeader title="Verizon Representative"/>
                <div className="margin-bot-10 center">
                    <h3 className="">{WelcomeStore.welcomeMessage}</h3>
                    { (EventStore.pollingStarted === false || EventStore.killPolling === true) &&
                        <div className="button" onClick={this.retryPolling}>Try Again</div>
                    }
                </div>
                <PageFooter />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/js/pages/WelcomePage.js